export default __webpack_public_path__ + "static/media/Cuvoo.9db1b33a.png";